import script from "./Visitors.vue?vue&type=script&setup=true&lang=ts"
export * from "./Visitors.vue?vue&type=script&setup=true&lang=ts"

import "./Visitors.vue?vue&type=style&index=0&id=11a43ecb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a43ecb"]])

export default __exports__